import React from 'react';
import PropTypes from 'prop-types';

const IconBase = ({ backgroundColor, classNames, children }) => (
  <svg
    className={`game-icon ${classNames}`}
    with="65"
    height="65"
    version="1.1"
    viewBox="0 0 65 65"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      transform="translate(-27 -25) translate(27 25)"
      fill="none"
      fillRule="evenodd"
    >
      <g fill={backgroundColor} fillRule="nonzero" className="background-fill">
        <circle cx="32.788" cy="32.788" r="25.885" />
        <circle cx="32.5" cy="32.5" r="32.5" opacity=".14844" />
        <circle cx="32.788" cy="32.788" r="28.761" opacity=".36593" />
      </g>
      <>{ children }</>
    </g>
  </svg>
);

IconBase.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  classNames: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export const Encryption = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-encryption"
  >
    <defs>
      <polygon
        id="a"
        points="0 3.4358 23.066 3.4358 23.066 0.2248 0 0.2248"
      />
      <polygon
        id="c"
        points="0 3.4358 23.066 3.4358 23.066 0.2248 0 0.2248"
      />
    </defs>
    <g transform="translate(21 27)" fill="#000" className="foreground-icon">
      <g transform="translate(.15888)">
        <path d="M0 1.83C0 .933.71.225 1.613.225S3.226.933 3.226 1.83A1.613 1.613 0 0 1 0 1.83" />
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <polygon
          points="6.9388 3.2758 23.066 3.2758 23.066 0.38477 6.9388 0.38477"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(11.799 9.8) rotate(180) translate(-11.64 -1.8)">
        <path d="M0 1.83C0 .933.71.225 1.613.225S3.226.933 3.226 1.83A1.613 1.613 0 0 1 0 1.83" />
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <polygon
          points="6.9388 3.2758 23.066 3.2758 23.066 0.38477 6.9388 0.38477"
          mask="url(#d)"
        />
      </g>
    </g>
  </IconBase>
);

Encryption.defaultProps = { backgroundColor: '#A593FF' };
Encryption.propTypes = { backgroundColor: PropTypes.string };

export const Deception = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-deception"
  >
    <path
      className="foreground-icon"
      transform="translate(1 1)"
      d="M38.737 45.013h-.013a.61.61 0 0 1-.613-.563l-1.434-18.191L35.1 39.624a.617.617 0 0 1-.608.54h-.017a.617.617 0 0 1-.617-.51l-1.386-8.093-1.134 4.578a.632.632 0 0 1-.661.465.615.615 0 0 1-.575-.564l-1.166-16.026-1.18 20.641a.615.615 0 0 1-.613.575h-.013a.616.616 0 0 1-.624-.55l-1.341-13.675-1.132 9.074a.617.617 0 0 1-.603.536.62.62 0 0 1-.636-.5l-1.471-7.849h-2.75v-.834h3.466l1.326 7.077 1.204-9.661a.613.613 0 0 1 .63-.536.612.612 0 0 1 .618.55l1.253 12.774 1.211-21.217a.614.614 0 0 1 .622-.576h.005c.333 0 .601.243.625.566l1.32 18.123 1.051-4.242a.621.621 0 0 1 .631-.466c.302.01.547.22.597.508l1.302 7.607 1.665-14.11a.612.612 0 0 1 .623-.54h.012a.61.61 0 0 1 .614.563l1.434 18.183 1.469-12.524h3.334v.834h-2.568L39.36 44.472a.612.612 0 0 1-.622.54"
      fill="#000"
      stroke="#000"
      strokeWidth=".58926"
    />
  </IconBase>
);

Deception.defaultProps = { backgroundColor: '#FF5252' };
Deception.propTypes = { backgroundColor: PropTypes.string };

export const SpecialOps = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-specialops"
  >
    <path
      className="foreground-icon"
      transform="translate(1 0.5)"
      d="M25.194 23.913l7.097 7.344 7.343-7.096a10.738 10.738 0 0 0-7.173-2.885c-2.69-.05-5.249.887-7.267 2.637zm-.85.822a10.738 10.738 0 0 0-2.885 7.173 10.744 10.744 0 0 0 2.638 7.268l7.344-7.097-7.097-7.344zm8.769 7.373l7.096 7.343c3.746-4.033 3.851-10.28.247-14.44l-7.343 7.096zm-8.194 7.919c4.032 3.745 10.28 3.852 14.44.246l-7.097-7.343-7.342 7.097zm7.36 4.064a11.965 11.965 0 0 1-8.212-3.241l-2.115 2.043-.82-.851 2.113-2.043a11.924 11.924 0 0 1-2.97-8.11 11.922 11.922 0 0 1 3.245-8.006l-2.043-2.113.852-.823 2.041 2.114a11.946 11.946 0 0 1 8.112-2.969 11.913 11.913 0 0 1 8.004 3.245l2.114-2.043.821.851-2.113 2.043c4.057 4.63 3.937 11.626-.276 16.115l2.044 2.114-.851.823-2.044-2.114a11.97 11.97 0 0 1-7.902 2.965z"
      fill="#000"
      stroke="#000"
      strokeWidth=".5"
    />
  </IconBase>
);

SpecialOps.defaultProps = { backgroundColor: '#85FF45' };
SpecialOps.propTypes = { backgroundColor: PropTypes.string };

export const MentalHorsepower = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-mentalhorsepower"
  >
    <g
      className="foreground-icon"
      transform="translate(22 22)"
      fill="#000"
    >
      <path d="M8.062 5.354h5.24V.382h-5.24v4.972zm1.746-1.656h1.749v-1.66h-1.75v1.66zM0 12.62h5.24V7.649H0v4.971zm1.554-1.474h2.133V9.123H1.554v2.023z" />
      <polygon points="10.683 7.6483 8.0621 12.62 13.302 12.62" />
      <polygon points="11.287 18.356 5.2404 18.356 5.2404 16.819 9.6625 16.819 9.6625 11.472 11.287 11.472" />
      <polygon points="3.2686 8.0307 1.6124 8.0307 1.6124 1.5297 8.4652 1.5297 8.4652 3.1038 3.2686 3.1038" />
      <polygon points="16.879 6.3061e-14 15.721 1.0988 19.803 4.9714 20.961 3.8726" />
      <polygon points="19.803 6.3061e-14 15.721 3.8726 16.879 4.9714 20.961 1.0988" />
      <polygon points="15.721 16.395 19.803 20.268 20.961 19.169 16.879 15.297" />
      <polygon points="15.721 19.169 16.879 20.268 20.961 16.395 19.803 15.297" />
      <path d="M20.942 10.25c0 1.403-1.186 2.54-2.649 2.54s-2.649-1.137-2.649-2.54 1.186-2.54 2.649-2.54 2.649 1.137 2.649 2.54M2.655 16.876c-.557 0-1.011.435-1.011.97s.454.97 1.012.97c.557 0 1.011-.435 1.011-.97s-.454-.97-1.011-.97m0 3.516C1.19 20.392 0 19.25 0 17.846S1.19 15.3 2.655 15.3c1.464 0 2.654 1.142 2.654 2.546s-1.19 2.546-2.655 2.546" />
    </g>
  </IconBase>
);

MentalHorsepower.defaultProps = { backgroundColor: '#434DCF' };
MentalHorsepower.propTypes = { backgroundColor: PropTypes.string };

export const Surveillance = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-surveillance"
  >
    <path
      className="foreground-icon"
      d="M43.542 31.938l-2.774 4.778 2.165.506 2.095-3.643zm-9.422 2.094l5.24 3.106 3.874-6.67-15.094-8.95-3.874 6.672 5.284 3.133 1.014 1.897-1.186 2.077a1.8 1.8 0 0 0-.383-.042c-.74 0-1.374.44-1.674 1.073h-2.946v-1.3h-2.157v-1.38H20.06v7.448h2.156V39.55h2.157v-1.6h2.946c.3.633.933 1.073 1.674 1.073a1.87 1.87 0 0 0 1.859-1.879c0-.303-.08-.586-.205-.84l1.2-2.12 2.262-.14z"
      fill="#000"
    />
  </IconBase>
);

Surveillance.defaultProps = { backgroundColor: '#2ad8d8' };
Surveillance.propTypes = { backgroundColor: PropTypes.string };

export const HotRisk = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-hotrisk"
  >
    <defs>
      <polygon id="a" points="0 24 30.883 24 30.883 0 0 0" />
    </defs>
    <mask id="b" fill="#fff">
      <use xlinkHref="#a" />
    </mask>
    <g
      transform="translate(17.397 20) translate(.58829 .21871)"
      fill="#000"
      className="foreground-icon"
    >
      <path d="M17.684 11.577c1.1 3.088.425 6.669-2.044 9.14a8.744 8.744 0 0 1-12.375 0 8.766 8.766 0 0 1 0-12.387 8.736 8.736 0 0 1 9.131-2.047l1.267-1.268 5.288 5.294-1.267 1.268zm-8.386 9.199a6.06 6.06 0 0 0 4.344-1.834 6.297 6.297 0 0 0 1.8-4.434 6.296 6.296 0 0 0-1.8-4.436 6.06 6.06 0 0 0-8.687 0c-2.395 2.446-2.395 6.425 0 8.87a6.06 6.06 0 0 0 4.343 1.834z" />
      <path d="M6.266 11.411a4.232 4.232 0 0 1 6.065 0 4.395 4.395 0 0 1 1.256 3.096c0 1.17-.446 2.27-1.256 3.097a4.232 4.232 0 0 1-6.065 0c-1.672-1.708-1.672-4.486 0-6.193zm4.53 4.779a1.508 1.508 0 0 0 .022-.925 1.287 1.287 0 0 0-.186-.378 1.475 1.475 0 0 0-.31-.315 1.703 1.703 0 0 0-.43-.233l-.703-.263a.499.499 0 0 1-.265-.202.53.53 0 0 1-.085-.283.48.48 0 0 1 .128-.33.507.507 0 0 1 .373-.148.586.586 0 0 1 .371.136.72.72 0 0 1 .152.18c.045.074.08.163.105.267l.861-.117a2.09 2.09 0 0 0-.148-.485 1.698 1.698 0 0 0-.23-.377 1.436 1.436 0 0 0-.626-.443v-.812h-.957v.802a1.352 1.352 0 0 0-.886.929 1.557 1.557 0 0 0 0 .855 1.396 1.396 0 0 0 .927.944l.65.212c.14.046.243.115.307.206a.499.499 0 0 1 .052.499.505.505 0 0 1-.13.182.687.687 0 0 1-.488.177c-.073 0-.148-.012-.22-.034s-.142-.06-.206-.108a.747.747 0 0 1-.174-.19.958.958 0 0 1-.121-.281l-.858.16c.042.188.102.356.179.504.077.148.166.276.267.385a1.476 1.476 0 0 0 .7.433v.773h.958v-.801c.146-.047.283-.112.41-.2.128-.084.239-.187.335-.307.095-.121.17-.258.226-.412zm8.681-8.546c-.328-.331-.835-.65-1.85-.17a4.972 4.972 0 0 0-1.237.862l-1.3-1.312c.03-.031.76-.764 1.76-1.235 1.491-.703 2.886-.51 3.925.542.658.664 1.186.333 1.288.26l.386-.341.467-.474 1.299 1.313-.536.54-.432.38c-.36.316-.965.588-1.66.588-.668 0-1.416-.25-2.11-.953z" />
      <polygon
        points="22.109 3.9403 24.215 3.9403 24.215 0 22.109 0"
        mask="url(#b)"
      />
      <polygon
        points="26.956 5.0149 25.618 3.6494 28.493 0.71642 29.83 2.0819"
        mask="url(#b)"
      />
      <polygon
        points="26.671 8.2388 30.532 8.2388 30.532 6.4478 26.671 6.4478"
        mask="url(#b)"
      />
    </g>
  </IconBase>
);

HotRisk.defaultProps = { backgroundColor: '#1BD7C3' };
HotRisk.propTypes = { backgroundColor: PropTypes.string };

export const Psychometrics = ({ backgroundColor }) => (
  <IconBase
    {...{ backgroundColor }}
    classNames="icon-psychometrics"
  >
    <g
      className="foreground-icon"
      transform="translate(19 20)"
    >
      <path
        fill="#000"
        d="M4.553 0v1.937h8.068V24.8h9.972v-1.937h-8.068V0z"
      />
      <g transform="translate(0 6.766)">
        <path
          d="M22.593 10.884c-2.887 0-5.236-2.4-5.236-5.328S19.705.23 22.593.23s5.237 2.4 5.237 5.327-2.35 5.328-5.237 5.328m0-8.718c-1.838 0-3.332 1.52-3.332 3.4s1.494 3.39 3.332 3.39 3.332-1.52 3.332-3.39-1.494-3.4-3.332-3.4"
          fill="#000"
        />
        <g transform="translate(0 .872)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            d="M6.418 8.026L4.546 6.122 2.674 8.026l-1.346-1.37L3.2 4.752 1.33 2.848l1.346-1.37 1.872 1.904L6.42 1.478l1.346 1.37-1.872 1.904 1.872 1.904-1.346 1.37zM0 9.385h9.106V.12H0v9.265z"
            fill="#000"
            mask="url(#b)"
          />
        </g>
      </g>
    </g>
  </IconBase>
);

Psychometrics.defaultProps = { backgroundColor: '#3f9adf' };
Psychometrics.propTypes = { backgroundColor: PropTypes.string };
